<template>
  <div class="pdfPrintButton text-xs-left pl-2 pt-2">
    <v-btn small color="blue darken-1" class="white--text pr-3" @click="generateReport">
      <v-icon class="mr-2" style="font-size:20px;" left dark>print</v-icon>Dashboard
    </v-btn>
    <v-dialog v-model="loaderDialog" hide-overlay persistent width="300">
      <v-card color="blue darken-1" dark>
        <v-card-text>
          Gerando PDF {{buildStatus}}%
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-btn fab dark color="indigo" small right @click="generateReport">
      <v-icon dark>print</v-icon>
    </v-btn>-->
    <!-- <v-btn color="success" @click="generateReport">gerar</v-btn> -->
    <vue-html2pdf
      :show-layout="false"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="dashboard"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="780px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section class="ml-3" slot="pdf-content" style="font-family: Helvetica, Arial, sans-serif;">
        <section
          style="font-family: Helvetica, Arial, sans-serif;"
          class="pdf-item"
          v-for="(typeDocs, ind) in typeDocList"
          :key="ind"
        >
          <v-layout row wrap white pb-2 mr-4 mb-5>
            <v-flex xs10>
              <p
                class="text-xs-left pb-0 py-1 mt-4 mb-0 pl-1 black--text"
              >{{ $store.state.docsReports.date_end | moment("MM/YYYY") }}</p>
            </v-flex>
            <v-flex xs2>
              <v-img :src="logo.src" class="mr-2 mt-1" height="auto" :alt="logo.title" />
            </v-flex>
            <v-flex xs12 text-xs-right>
              <p
                class="text-xs-right primary py-1 pr-3 white--text pt-0 mt-0"
              >{{$store.state.docsReports.condominiumName}}</p>
            </v-flex>

            <v-flex
              pt-3
              title
              text-xs-left
              xs12
              style="border-bottom: 2px solid #c62828;"
            >DOCUMENTOS E CONTRATOS</v-flex>

            <v-flex xs6 pl-1 pb-4 pt-1 mb-2>
              <h2 class="caption text-xs-left pl-0">Visão geral</h2>
            </v-flex>

            <v-flex xs6 row pr-0 layout pb-4 pt-1 mb-2>
              <v-spacer></v-spacer>
              <div class="statusRounded ml-2 mr-1 mt-0" style="background:#4caf50;"></div>
              <span class="mr-3 caption">Vigentes</span>
              <div class="statusRounded ml-2 mr-1 mt-0" style="background:#ffab00;"></div>
              <span class="mr-3 caption">A vencer</span>
              <div class="statusRounded ml-2 mr-1 mt-0" style="background:#c62828;"></div>
              <span class="mr-1 caption">Vencidos</span>
              <div class="statusRounded ml-2 mr-1 mt-0" style="background:#696A6D;"></div>
              <span class="mr-1 caption">Em obtenção</span>
            </v-flex>

            <v-flex xs4 mt-1 mb-4 px-1 v-for="(typeDoc, i) in typeDocList[ind]" :key="i">
              <DocumentsChartsPdfDashboard
                :type_id="typeDoc['type_id']"
                :docName="typeDoc['type_name']"
                :series="typeDoc['statuses']"
                :expiredsDocs="typeDoc['expiredList']"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap white pb-0 mr-4 pt-3>
            <v-flex xs12 mx-2>
              <p
                class="pb-1 mb-0 pt-3"
                style="font-size:11px;"
              >Em análise, são os documentos aos quais estamos apurando se se aplicam ao condomínio. Para mais informações destes documentos vide planilhas (anexo II) coluna "Status".</p>
            </v-flex>
            <v-flex xs12 mx-2>
              <p
                class="pb-2 mb-0"
                style="font-size:11px;"
              >Alguns documentos possuem prazo/dias de alerta de vencimentos diferenciado devido ao tempo de renovação. Para maiores informações destes prazos vide planilha (anexo I), coluna "Prazo de vencimento"</p>
            </v-flex>
            <v-flex
              pb-0
              mb-0
              pt-2
              caption
              text-xs-right
              xs12
              style="border-top: 2px solid #c62828;"
            >{{`${(ind+1) > 9 ? (ind+1) : '0'+(ind+1)}`}}</v-flex>
          </v-layout>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import DocumentsChartsPdfDashboard from './DocumentsChartsPdfDashboard'

export default {
  name: 'DashboardPDF',

  components: {
    VueHtml2pdf,
    DocumentsChartsPdfDashboard
  },

  data () {
    return {
      logo: {
        restrictedarea: 'Área restrita',
        src: './img/logo.png',
        title: 'InSight Síndicos',
        txt: 'Faça login para acessar o sistema.'
      },
      buildStatus: 0,
      loaderDialog: false,
      typeDocList: []
    }
  },

  watch: {
    buildStatus (v) {
      console.log(v)
      if (v > 0 && v < 100) {
        this.loaderDialog = true
      } else {
        this.loaderDialog = false
      }
    }
  },

  methods: {
    dismemberArr (base, maximo) {
      var resultado = [[]]
      var grupo = 0

      for (var indice = 0; indice < base.length; indice++) {
        if (resultado[grupo] === undefined) {
          resultado[grupo] = []
        }

        resultado[grupo].push(base[indice])

        if ((indice + 1) % maximo === 0) {
          grupo = grupo + 1
        }
      }
      return resultado
    },

    async getReports () {
      // console.log(this.$store.state.docsReports.condominium_id);
      let data = {
        condominium_id: this.$store.state.docsReports.condominium_id,
        date_end: this.$store.state.docsReports.date_end
      }
      let obj = {
        url: '/api/reports_docs',
        query: data,
        method: 'post'
      }

      await this.$store.dispatch('request/doRequest', obj).then(response => {
        let charts = response.data.filter((type, i) => {
          console.log('indice', i)
          if (type.statuses[0] || type.statuses[1] || type.statuses[2] || type.statuses[3]) {
            return type
          }
        })
        let dismembers = this.dismemberArr(charts, 6)
        this.typeDocList = [...dismembers]
        // console.log(this.typeDocs);
      })
    },
    hasGenerated (a) {
      console.log(a)
    },
    onProgress (d) {
      this.buildStatus = d
    },
    generateReport () {
      this.getReports().then(_ => {
        this.loaderDialog = true
        setTimeout(() => {
          this.$refs.html2Pdf.generatePdf()
        }, 2000)
      })
    }
  }
}
</script>

<style>
</style>
